<template>
  <v-container>
    <v-row>
      <div v-if="notAuthed">
          <v-text-field
            value="User not authenticated"
            type="datetime"
            append-icon="mdi-user"
            readonly
            rounded
            dense
            outlined
          ></v-text-field>
      </div>
      <div v-else-if="noAccess">
          <v-text-field
            value="User does not have access to comments"
            type="datetime"
            append-icon="mdi-user"
            readonly
            rounded
            dense
            outlined
          ></v-text-field>
      </div>
      <div v-else-if="isRequestOk">
        <v-col
          v-for="comment in comments"
          :key="comment.id"
          cols="6"
        >
          <v-text-field
            label="Starts at:"
            :value="comment.text"
            type="datetime"
            append-icon="mdi-user"
            readonly
            rounded
            dense
            outlined
          ></v-text-field>
        </v-col>
      </div>
      <div v-else>
        <v-col
          v-for="comment in comments"
          :key="comment"
          cols="6"
        >
          <v-text-field
            value="Error loading comments"
            type="datetime"
            append-icon="mdi-user"
            readonly
            rounded
            dense
            outlined
          ></v-text-field>
        </v-col>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Comments',
  props: ['activityId'],
  methods: {
    ...mapActions(['fetchComments'])
  },
  computed: {
    ...mapGetters(['comments']),
    notAuthed() {
      if (!isNaN(this.comments) &&  this.comments == 401) {
        return true
      }
      return false
    },
    noAccess() {
      if (!isNaN(this.comments) &&  this.comments == 403) {
        return true
      }
      return false
    },
    isRequestOk() {
      if (Array.isArray(this.comments)) {
        return true
      }
      return false
    }
  },
  created() {
    this.fetchComments(this.$route.params.activityId)
  }
}
</script>